// extracted by mini-css-extract-plugin
export default {"remove":"ThucDonPage_remove__YEBmk"};